import { Link, Outlet } from "react-router-dom";
import {
  BuildingOffice2Icon,
  PowerIcon,
} from "@heroicons/react/24/outline";

const SuperAdminLayout = () => {
  return (
    <div className="flex flex-row w-full min-h-screen bg-slate-100">
      <aside className="hidden lg:flex flex-col min-w-[250px] w-[250px] bg-primary text-stone-200 p-4">
        <div className="fixed">
          <h3 className="uppercase text-2xl font-bold text-white">
            Super Admin
          </h3>
          <ul className="md:flex-col md:min-w-full flex flex-col list-none mt-8 gap-2">
            <li>
              <Link
                to="/su/admin/tenants"
                className="flex items-center gap-2 py-2 px-2 rounded hover:bg-primary-dark"
              >
                <BuildingOffice2Icon className="w-4 h-4" />
                Tenants
              </Link>
            </li>
            <li>
              <Link
                to="/su/admin/logout"
                className="flex items-center gap-2 py-2 px-2 rounded hover:bg-primary-dark"
              >
                <PowerIcon className="w-4 h-4" />
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </aside>
      <main className="flex flex-col grow">
        <div className="fixed left-0 lg:left-[250px] right-0 top-0 z-20 h-20 bg-white shadow flex items-center justify-between px-8">
          <Link
            to="/su/admin/tenants"
            className="lg:hidden uppercase text-primary font-bold"
          >
            Super Admin
          </Link>
          <div className="hidden lg:block uppercase text-slate-500 text-sm font-bold">
            Platform Console
          </div>
          <Link
            to="/su/admin/logout"
            className="text-sm uppercase font-semibold text-slate-600"
          >
            Logout
          </Link>
        </div>
        <div className="p-8 mt-20">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SuperAdminLayout;
